module.exports = __webpack_public_path__ + "img/menu-travel.ce9e29f.svg";